import React from 'react';
import SimpleAwardBlock from './SimpleAwardBlock';
import styles from './BiggestAwardBlock.css';
import BitBackground from '../BitBackground';

const BiggestAwardBlock = ({ subTitle, className, nominees, ...props }) => {
  if (props.hasWinner || !nominees || !Array.isArray(nominees)) {
    return (
      <SimpleAwardBlock
        {...props}
        isLong
        className={className}
      />
    );
  }

  return (
    <div className={`${styles.biggest} ${className || ''}`}>
      <SimpleAwardBlock
        {...props}
        className={styles.awardBlock}
        isLong
      />

      <h3>{subTitle}</h3>

      <div className={styles.nominees}>
        {nominees.map((nominee, i) => (
          <img src={nominee.img} alt={nominee.name} key={`${nominee.name}-${i}`} />
        ))}

        <BitBackground className={styles.bitBackground} />
      </div>
    </div>
  );
};

export default BiggestAwardBlock;



// WEBPACK FOOTER //
// ./src/components/AwardBlock/BiggestAwardBlock.js